import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import WebpImg from 'components/WebpImg';
import { giftList } from 'utils/voting2025';

export const RotateItem = ({
  awards,
  awardIdx = 0,
  className = '',
} = props) => {
  const award = awards[awardIdx];
  const { name, display_name: displayName, price, image } = award;
  // 20 14
  // 14 10
  return (
    <div
      className={classnames(
        'absolute flex h-full w-[208px] flex-col items-center justify-start gap-y-3 rounded-[32px] border-[2px] border-[#4F4E4F] bg-white px-2 py-4',
        className
      )}
    >
      <p className="font-jinxuanlatte text-[24px] font-bold text-sorra-pink">
        {awardIdx == 0 ? '人氣大獎' : awardIdx == 1 ? '二獎' : '三獎'}
      </p>
      <div className="relative h-[102px] w-[102px] rounded-full border border-[#4F4E4F]">
        <WebpImg
          src={image ? image.url : '/images/placeholders/product.png'}
          className="h-full w-full overflow-hidden rounded-full object-contain"
        />
        {awardIdx == 0 && (
          <div className="absolute bottom-0 right-0 translate-y-1/4 text-[32px] font-bold">
            🇯🇵
          </div>
        )}
      </div>
      <div className="text-center text-black">
        <p
          className="whitespace-pre-line font-rubik"
          style={{
            fontSize: awardIdx == 0 ? `20px` : '16px',
          }}
        >
          {displayName || name}
        </p>
        <p
          className="mt-1"
          style={{
            fontSize: awardIdx == 0 ? `14px` : '12px',
          }}
        >
          {price}
        </p>
      </div>
      {/* <div className="rounded-full bg-sorra-pink px-2 py-1 text-xs font-medium text-white">
        {count}
      </div> */}
    </div>
  );
};

export const InfoIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4001 7.99961C14.4001 9.697 13.7258 11.3249 12.5256 12.5251C11.3253 13.7253 9.69748 14.3996 8.0001 14.3996C6.30271 14.3996 4.67485 13.7253 3.47461 12.5251C2.27438 11.3249 1.6001 9.697 1.6001 7.99961C1.6001 6.30222 2.27438 4.67436 3.47461 3.47413C4.67485 2.27389 6.30271 1.59961 8.0001 1.59961C9.69748 1.59961 11.3253 2.27389 12.5256 3.47413C13.7258 4.67436 14.4001 6.30222 14.4001 7.99961V7.99961ZM8.8001 4.79961C8.8001 5.01178 8.71581 5.21527 8.56578 5.36529C8.41575 5.51532 8.21227 5.59961 8.0001 5.59961C7.78792 5.59961 7.58444 5.51532 7.43441 5.36529C7.28438 5.21527 7.2001 5.01178 7.2001 4.79961C7.2001 4.58744 7.28438 4.38395 7.43441 4.23392C7.58444 4.0839 7.78792 3.99961 8.0001 3.99961C8.21227 3.99961 8.41575 4.0839 8.56578 4.23392C8.71581 4.38395 8.8001 4.58744 8.8001 4.79961ZM7.2001 7.19961C6.98792 7.19961 6.78444 7.2839 6.63441 7.43392C6.48438 7.58395 6.4001 7.78744 6.4001 7.99961C6.4001 8.21178 6.48438 8.41527 6.63441 8.56529C6.78444 8.71532 6.98792 8.79961 7.2001 8.79961V11.1996C7.2001 11.4118 7.28438 11.6153 7.43441 11.7653C7.58444 11.9153 7.78792 11.9996 8.0001 11.9996H8.8001C9.01227 11.9996 9.21575 11.9153 9.36578 11.7653C9.51581 11.6153 9.6001 11.4118 9.6001 11.1996C9.6001 10.9874 9.51581 10.784 9.36578 10.6339C9.21575 10.4839 9.01227 10.3996 8.8001 10.3996V7.99961C8.8001 7.78744 8.71581 7.58395 8.56578 7.43392C8.41575 7.2839 8.21227 7.19961 8.0001 7.19961H7.2001Z"
        fill="#F16B7C"
      />
    </svg>
  );
};

export const ExpandInstructions = (props) => {
  return (
    <div className="mt-3 rounded-lg bg-[#F5F5F5] p-2 text-center text-xs font-normal text-[#111928]">
      本年度提名名單由<span className="font-bold">網路趨勢</span>與
      <span className="font-bold">零售實績</span>共同組成，
      <br />
      確保入圍產品兼具話題性與實力：
      <br />
      <span className="font-bold">• 50% Sorra 趨勢指標：</span>
      <br />
      sorra.net 2025年度評價成長率最高的產品
      <br />
      <span className="font-bold">• 50% Sa Sa 零售指標：</span>
      <br />
      Sa Sa 2025年度線上線下的熱賣產品。
    </div>
  );
};

export const SorraCircle = ({ className = '' } = props) => {
  return (
    <div className={classnames('absolute', className)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 12 12"
        fill="none"
      >
        <g clipPath="url(#clip0_2113_3128)">
          <path
            d="M6.00001 11.5329C9.05569 11.5329 11.5328 9.05575 11.5328 6.00007C11.5328 2.9444 9.05569 0.467285 6.00001 0.467285C2.94434 0.467285 0.467224 2.9444 0.467224 6.00007C0.467224 9.05575 2.94434 11.5329 6.00001 11.5329Z"
            fill="white"
            stroke="#6D6D6D"
            strokeWidth="0.75"
            strokeMiterlimit="10"
          />
        </g>
        <defs>
          <clipPath id="clip0_2113_3128">
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export const SorraStar = ({ className = '' } = props) => {
  return (
    <div className={classnames('absolute', className)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 29"
        fill="none"
      >
        <g clipPath="url(#clip0_2238_2134)">
          <path
            d="M10.0059 28.2525C9.14049 28.2525 8.38175 27.6297 8.1802 26.7328C7.48074 23.6434 5.69058 18.1624 1.63604 16.1942C0.972143 15.8703 0.557205 15.1852 0.557205 14.4129C0.557205 13.6405 0.972143 12.9554 1.63604 12.6315C5.69058 10.6633 7.46888 5.1823 8.1802 2.09299C8.38175 1.19609 9.12863 0.573242 10.0059 0.573242C10.8832 0.573242 11.6301 1.19609 11.8317 2.09299C12.5311 5.1823 14.3213 10.6633 18.3758 12.6315C19.0397 12.9554 19.4547 13.6405 19.4547 14.4129C19.4547 15.1852 19.0397 15.8703 18.3758 16.1942C14.3213 18.1624 12.543 23.6434 11.8317 26.7328C11.6301 27.6297 10.8832 28.2525 10.0059 28.2525Z"
            fill="#FBEBDE"
          />
          <path
            d="M10.0059 1.15849C10.6224 1.15849 11.1559 1.59448 11.2982 2.22979C12.0213 5.41876 13.8826 11.0867 18.1506 13.1545C18.6248 13.3787 18.9093 13.8645 18.9093 14.4126C18.9093 14.9608 18.6129 15.4466 18.1506 15.6708C13.8826 17.7386 12.0332 23.4065 11.2982 26.5955C11.1559 27.2308 10.6224 27.6668 10.0059 27.6668C9.38945 27.6668 8.85596 27.2308 8.71369 26.5955C7.99052 23.4065 6.12922 17.7386 1.86129 15.6708C1.38708 15.4466 1.10255 14.9608 1.10255 14.4126C1.10255 13.8645 1.39893 13.3787 1.86129 13.1545C6.12922 11.0867 7.97866 5.41876 8.70184 2.22979C8.8441 1.59448 9.37759 1.15849 9.99407 1.15849M10.0059 0C8.87967 0 7.90753 0.809699 7.64671 1.96819C6.97095 4.95785 5.25193 10.2396 1.41079 12.1081C0.533491 12.5192 0 13.4036 0 14.4126C0 15.4217 0.533491 16.3061 1.39893 16.7296C5.24007 18.5982 6.9591 23.8799 7.63485 26.8696C7.89567 28.0281 8.86781 28.8378 9.99407 28.8378C11.1203 28.8378 12.0925 28.0281 12.3533 26.8696C13.029 23.8799 14.7481 18.5982 18.5892 16.7296C19.4547 16.3061 19.9881 15.4217 19.9881 14.4126C19.9881 13.4036 19.4547 12.5192 18.5892 12.1081C14.7481 10.2396 13.029 4.95785 12.3533 1.96819C12.0925 0.809699 11.1203 0 9.99407 0H10.0059Z"
            fill="#6D6D6D"
          />
        </g>
        <defs>
          <clipPath id="clip0_2238_2134">
            <rect width="20" height="28.8253" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export const BeautyAwards2025ShadowFrame = (props) => {
  const { children, className } = props;
  return (
    <div
      style={{
        boxShadow: '-8px 8px 0 0 #F8A5B1',
      }}
      className={classnames(
        'relative mb-2 ml-0 overflow-visible rounded-[24px] border-[2px] border-[#4F4E4F] bg-[#FFFCFB] px-6 pb-6 pt-0',
        className
      )}
    >
      {children}
    </div>
  );
};

export const BeautyAwards2025TitleFrame = (props) => {
  const { children } = props;
  return (
    <div className="font-jinxuanlatte mx-3 -mt-10 flex flex-col items-center rounded border border-[#4F4E4F] bg-[#FCECDF] p-2 text-center text-lg font-bold text-[#4F4E4F]">
      {children}
    </div>
  );
};
